/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const PendingDeletionReasonDTOSourceEnum = {
    AutoDeleteFilter: 'AUTO_DELETE_FILTER',
    Manual: 'MANUAL',
    InventoryAction: 'INVENTORY_ACTION',
    FeedRule: 'FEED_RULE',
    AutoAddFilter: 'AUTO_ADD_FILTER',
    Staging: 'STAGING',
    InactiveCleanup: 'INACTIVE_CLEANUP',
    BusinessReport: 'BUSINESS_REPORT',
    Unknown: 'UNKNOWN'
};
/**
 * Check if a given object implements the PendingDeletionReasonDTO interface.
 */
export function instanceOfPendingDeletionReasonDTO(value) {
    return true;
}
export function PendingDeletionReasonDTOFromJSON(json) {
    return PendingDeletionReasonDTOFromJSONTyped(json, false);
}
export function PendingDeletionReasonDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'source': json['source'] == null ? undefined : json['source'],
        'detail': json['detail'] == null ? undefined : json['detail'],
        'filterName': json['filterName'] == null ? undefined : json['filterName'],
        'matchedValue': json['matchedValue'] == null ? undefined : json['matchedValue'],
    };
}
export function PendingDeletionReasonDTOToJSON(json) {
    return PendingDeletionReasonDTOToJSONTyped(json, false);
}
export function PendingDeletionReasonDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'source': value['source'],
        'detail': value['detail'],
        'filterName': value['filterName'],
        'matchedValue': value['matchedValue'],
    };
}
